export default __webpack_public_path__ + "static/media/Karnataka5.9abf79ea.png";